import { ToggleButton, ToggleButtonGroup } from '@mui/material';

import { isDefined } from 'common';

export enum Weekday {
  Sunday = 'Sunday',
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
}

interface WeekDaysSelectorProps {
  selectedDays?: Weekday[];
  onChange: (days: Weekday[]) => void;
  disabled?: boolean;
}

export function WeekDaysSelector(props: WeekDaysSelectorProps) {
  const { selectedDays = [], onChange, disabled = false } = props;

  return (
    <ToggleButtonGroup
      value={selectedDays}
      onChange={(_, newValue) => {
        if (isDefined(newValue)) {
          onChange(newValue);
        }
      }}
      disabled={disabled}
      size="small"
      fullWidth
    >
      {Object.values(Weekday).map((day) => (
        <ToggleButton key={day} value={day} aria-label={day}>
          {day.substring(0, 3)}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
